import apiAxios from 'helpers/apiAxios';

export const searchPaymentEntries = (params, signal) =>
  apiAxios.get('/erp/payment_entries', { params, signal }).then((response) => response.data);

export const createPaymentEntry = (payload) =>
  apiAxios.post('/erp/payment_entries', payload).then((response) => response.data.data);
